import {Link, useNavigate} from "react-router-dom";
import styles from "../signUp/signUp.module.css";
import {useEffect, useRef} from "react";
import {UserAuth} from "../../context/AuthContext";

const LogIn = () => {
	const navigate = useNavigate()
	const {user ,logOut} = UserAuth();
	const emailRef = useRef();
	const passwordRef = useRef();
	console.log(user)

	const logout = async () => {
		try
		{
			await logOut();
			navigate('../')
		}
		catch (e)
		{
			console.log(e)
		}
	}

	useEffect(() => {
		if (user) {
			logout()
		}
	},[])

	return (
		<>
			{user && logout()}
			<div className={styles.container}>
				<div className={styles.card}>
					<h1 className={styles.header}>Log In </h1>
					<form className={styles.form}>
						<input ref={emailRef} type="email" placeholder="Email Id"/>
						<input ref={passwordRef} type="password" placeholder="Password"/>
						<button type="submit">Submit</button>
					</form>
					<div>Don't Have account? <Link to="/signUp">Sign Up</Link></div>
				</div>
			</div>
		</>
	)
}

export default LogIn;